import classNames from "classnames";
import { useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  collapseWhitespace,
  formatBlockedChars,
  getDisallowedChars,
  stripDisallowedChars,
} from "../../../utils/latinCharset";

function FormEntry({
  name,
  value,
  labelText,
  handleChange,
  isInvalid,
  type = "text",
  required = true,
}) {
  const { t } = useTranslation(["register"]);
  const [blockedChars, setBlockedChars] = useState([]);

  // Passwords may contain any character, so they are never restricted.
  // For all other fields, disallowed characters (non-Latin scripts, etc.)
  // are dropped before they reach the form state and a hint naming the
  // rejected characters is shown.
  const onChange = (event) => {
    if (type === "password") {
      return handleChange(event);
    }
    const original = event.target.value;
    const cleaned = collapseWhitespace(stripDisallowedChars(original));
    setBlockedChars(getDisallowedChars(original));
    return handleChange({ target: { name, value: cleaned } });
  };

  return (
    <div className="mb-md-3">
      <FloatingLabel controlId={`Input-${name}`} label={labelText}>
        <Form.Control
          onChange={onChange}
          value={value}
          type={type}
          className={classNames("register-form-control", {
            "is-invalid": isInvalid(name),
          })}
          placeholder={labelText}
          name={name}
          required={required}
        />
        <Form.Control.Feedback type="invalid" tooltip>
          <ErrorText name={name} isInvalid={isInvalid} />
        </Form.Control.Feedback>
      </FloatingLabel>
      {blockedChars.length > 0 && (
        <div className="register-charset-hint small text-danger mt-1">
          {t("error.charSet", { ns: "register", chars: formatBlockedChars(blockedChars) })}
        </div>
      )}
    </div>
  );
}

export default FormEntry;

export function ErrorText({ name, isInvalid }) {
  const { t } = useTranslation(["register"]);
  let errorcode = isInvalid(name)?.msg?.code;

  let text;
  switch (Number(errorcode)) {
    case 1:
      text = t("error.codes._1_required", {
        ns: "register",
      });
      break;

    case 2:
      text = t("error.codes._2_typeError", {
        ns: "register",
      });
      break;

    case 3:
      text = t("error.codes._3_length", {
        ns: "register",
      });
      break;

    case 4:
      text = t("error.codes._4_email", {
        ns: "register",
      });
      break;

    case 5:
      text = t("error.codes._5_inUse", {
        ns: "register",
      });
      break;

    case 6:
      text = t("error.codes._6_invalidOption", {
        ns: "register",
      });
      break;

    case 7:
      text = t("error.codes._7_charset", {
        ns: "register",
      });
      break;

    default:
      text = t("error.codes.unknown", {
        ns: "register",
      });

      break;
  }

  return <div>{text}</div>;
}
